<template>
  <a
    class="m-card-element m-card-element-design-1 m-card-primary m-card-transition"
    href="#"
    @click.prevent="$modal.showModal(modalBody, modalElement)">
    <div>
      <span :class="`a-button-${$route.name}-primary`">
        <i class="far fa-plus"></i>
      </span>
      <h2 :class="elementClass">
        {{ elementType }}
      </h2>
    </div>
  </a>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentCardDesign1',

  computed: {
    elementClass () {
      return this.$route.name === 'projects'
        ? 'text-color-assets-primary'
        : 'text-color-products-primary'
    },

    elementType () {
      return this.$route.name === 'projects'
        ? this.$t('mFeedSectionContentCardDesign1.projects')
        : this.$t('mFeedSectionContentCardDesign1.products')
    },

    modalBody () {
      // TODO Validar en el modal si puede crear curso o si puede crear mapa, las cantidades son independientes
      // Puede suceder que haya alcanzado una pero no la otra y hay que permitirle crear según sea el caso
      if (this.$route.name === 'products') {
        return this.$license.isMaximumReached('productos')
          ? 'MoleculeLicenseModalUpgrade'
          : 'MoleculeFeedProductsContentModalCreate'
      } else if (this.$route.name === 'projects') {
        return 'MoleculeFeedProjectsContentModalCreate'
      }
      return null
    },

    modalElement () {
      return this.$route.name === 'products'
        ? 'productos'
        : 'proyectos'
    }
  }
}
</script>
